import { getPatchedDataSchema } from '@tencent/data-schema-core';
import { arrayify } from "../../lib/utils/array";
import { cloneDeep, uniqBy } from "lodash-es";
export function getVNodeFactoryState(renderer, compPath) {
  if (!renderer) return undefined;
  // 这只是加个 Vue 依赖，保证 getRefByPath 为 computed 的时候是响应式的
  // eslint-disable-next-line
  renderer.ucVNodeFactory;
  return renderer.ucVNodeFactoryContext.factoryStates[compPath];
}
export function getVNodeFactory(renderer, compPath) {
  var _getVNodeFactoryState;
  return (_getVNodeFactoryState = getVNodeFactoryState(renderer, compPath)) === null || _getVNodeFactoryState === void 0 ? void 0 : _getVNodeFactoryState.factory;
}
/**
 * 根据组件/DOM实例/compPath/组件ID，获取他在 renderer 里对应的 compPath
 *
 * @param target 可以是一个 compPath，一个组件ID，或者一个组件实例
 * @return compPath
 */
export function getCompPathOf(renderer, target) {
  if (!renderer) return null;
  if (typeof target === 'string') {
    var _tempTarget$$vnode;
    // 如果传入的是个 compPath 格式，就直接返回
    if (/^(\/[^/]+\/\d+)*$/.test(target)) return target;
    // 传入的是一个组件ID
    const tempTarget = renderer.getRef(target);
    const tempPath = tempTarget === null || tempTarget === void 0 || (_tempTarget$$vnode = tempTarget.$vnode) === null || _tempTarget$$vnode === void 0 || (_tempTarget$$vnode = _tempTarget$$vnode.data) === null || _tempTarget$$vnode === void 0 ? void 0 : _tempTarget$$vnode['uc:path'];
    if (typeof tempPath === 'string') return tempPath;
  }
  if (typeof target === 'object' && target) {
    var _vuePtr;
    let vuePtr;
    if ('_isVue' in target) {
      // 传入的就是一个 Vue 实例
      vuePtr = target;
    } else {
      // 传入的是一个 DOM 元素，要使用 Vue 挂在元素上的 __vue__ 来寻找
      for (let p = target; !!p; p = p.parentElement) {
        vuePtr = p.__vue__;
        if (vuePtr) break;
      }
    }
    if (!((_vuePtr = vuePtr) !== null && _vuePtr !== void 0 && _vuePtr._isVue)) return null;
    // 找到了 Vue 实例，可以考虑向上搜索
    for (; !!vuePtr; vuePtr = vuePtr.$parent) {
      var _vuePtr$$vnode;
      const iRenderer = (_vuePtr$$vnode = vuePtr.$vnode) === null || _vuePtr$$vnode === void 0 || (_vuePtr$$vnode = _vuePtr$$vnode.data) === null || _vuePtr$$vnode === void 0 ? void 0 : _vuePtr$$vnode['uc:renderer'];
      if (!iRenderer || iRenderer !== renderer) continue;
      if (vuePtr._uid === renderer._uid) return null; // NOTHING
      return vuePtr.$vnode.data['uc:path'];
    }
  }
}
// eslint-disable-next-line max-len
export function getComponentMethodDeclarations(renderer, compPath) {
  var _renderer$ucFactoryLU;
  const compInstance = renderer.getRefByPath(compPath);
  const compMeta = (_renderer$ucFactoryLU = renderer.ucFactoryLUT.byCompPath[compPath]) === null || _renderer$ucFactoryLU === void 0 ? void 0 : _renderer$ucFactoryLU.compMeta;
  let methods = compMeta === null || compMeta === void 0 ? void 0 : compMeta.methods;
  const methodsPostProcessor = arrayify(compInstance === null || compInstance === void 0 ? void 0 : compInstance.$options.ucMethods);
  if (compInstance && methodsPostProcessor.length) {
    const temp = cloneDeep(methods || []);
    methodsPostProcessor.forEach(fn => fn.call(compInstance, temp));
    methods = getPatchedDataSchema({
      type: 'object',
      methods: temp
    }).methods;
  }
  return Object.seal(uniqBy(methods || [], 'id'));
}
// eslint-disable-next-line max-len
export function getComponentEventDeclarations(renderer, compPath) {
  var _renderer$ucFactoryLU2, _events;
  const compInstance = renderer.getRefByPath(compPath);
  const compMeta = (_renderer$ucFactoryLU2 = renderer.ucFactoryLUT.byCompPath[compPath]) === null || _renderer$ucFactoryLU2 === void 0 ? void 0 : _renderer$ucFactoryLU2.compMeta;
  let events = compMeta === null || compMeta === void 0 ? void 0 : compMeta.events;
  const eventsPostProcessor = arrayify(compInstance === null || compInstance === void 0 ? void 0 : compInstance.$options.ucEvents);
  if (compInstance && eventsPostProcessor.length) {
    const temp = cloneDeep(events || []);
    eventsPostProcessor.forEach(fn => fn.call(compInstance, temp));
    events = temp;
  }
  events = (_events = events) === null || _events === void 0 ? void 0 : _events.map(x => {
    if (x.asProp) return {
      ...x,
      id: `:${x.asProp}`
    };
    return x;
  });
  return Object.seal(uniqBy(events || [], 'id'));
}
export function getSlotFromElement(renderer, compPath, target) {
  var _getVNodeFactoryState2;
  const slots = (_getVNodeFactoryState2 = getVNodeFactoryState(renderer, compPath)) === null || _getVNodeFactoryState2 === void 0 ? void 0 : _getVNodeFactoryState2.getNormalSlots();
  return (slots === null || slots === void 0 ? void 0 : slots.find(slot => {
    var _slot$getSlotContaine;
    if (slot.frozen) return false;
    const el = (_slot$getSlotContaine = slot.getSlotContainerElement) === null || _slot$getSlotContaine === void 0 ? void 0 : _slot$getSlotContaine.call(slot);
    return el && (el === target || el.contains(target));
  })) || null;
}
//# sourceMappingURL=utils.js.map
